module.exports = __webpack_public_path__ + "img/user-gri.c42bc2dd.svg";